import { Button } from '@/components/ui/button.js';
import { useToast } from '@/components/ui/hooks/use-toast.js';
import { Copy } from 'lucide-react';
import { ComponentProps } from 'react';

interface CopyButtonProps {
  content: string;
  buttonProps?: ComponentProps<typeof Button> & { 'data-testid'?: string };
}

export function CopyButton({ content, buttonProps = {} }: CopyButtonProps) {
  const { toast } = useToast();
  const { className, ...rest } = buttonProps;

  return (
    <Button
      type="button"
      icon={Copy}
      onClick={() => {
        navigator.clipboard.writeText(content).then(() => {
          toast({
            title: 'Copied to clipboard',
          });
        });
      }}
      size={'sm'}
      variant={'ghost'}
      className={className}
      {...rest}
    />
  );
}
